import { CarrierCard } from './CarrierCard'
import { CarrierDataLoader } from './CarrierDataLoader'

export const CarrierPopoverCard = CarrierDataLoader(CarrierCard)
